import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, HostBinding, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Global } from '../../shared/global';


@Component({
  selector: 'app-right-container',
  templateUrl: './right-container.component.html',
  host: {'[class.test]': 'isResult'},
  styleUrls: ['./right-container.component.scss'],
  animations: [
    trigger('fade', [
      state('false', style({ opacity: 0 })),
      state('true', style({ opacity: 1 })),
      transition('false => true', animate('250ms ease-in')),
      transition('true => false', animate('250ms ease-out'))
    ]),
  ]
})
export class RightContainerComponent implements OnInit {
  isHome: boolean;
  mobileEnabled: boolean = false;
  isResult: boolean = true;  
  currentYear = new Date().getFullYear();
  public isChanged: boolean;
  @HostBinding('style.flex') flex: number;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth < 767) {
      this.mobileEnabled = true;
    } else {
      this.mobileEnabled = false;
    }
  }

  @HostListener('click') onClick() {
    if (this.global.isResult) {
      this.flex = 2.1;
    } else {
      this.flex = 1;
    }
  }
  // when someone click the browser back button
  @HostListener( 'window: popstate', ['$event'])
  onPopState(event: Event): void {
    this.global.isResult = false;
    this.flex = 1;
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    this.redirectHome();
  }

  constructor(private router: Router, public global: Global) {
    // console.log('for testing');
    this.mobileEnabled = window.innerWidth < 767;

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
  });
  }
  redirectHome() {
    //this.router.navigateByUrl('/');
    this.router.navigate(['/'], { queryParams: { org: this.global.orgID } });
  }
  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(route => {
        this.isHome = route['url'] === '/';
      });
  }


}
